module.exports = __webpack_public_path__ + "img/bckarw.2382782e.svg";